/* eslint-disable */
function isValidColor(strColor) {
  const s = new Option().style;
  s.color = strColor;
  return s.color !== '';
}

function getColor(color, defaultColor) {
  if (isValidColor(color)) return color;
  return defaultColor;
}

export function addDefaults(styles) {
  const stylesWithDefaults = styles ? { ...styles } : {};

  const defaults = [
    { fieldName: 'headerBackgroundColor', defaultValue: '#FFFFFF' },
    { fieldName: 'headerFontColor', defaultValue: '#FFFFFF' },
    { fieldName: 'widgetButtonBackgroundColor', defaultValue: '#1B5BD8' },
    { fieldName: 'widgetButtonFontColor', defaultValue: '#FFFFFF' },
    { fieldName: 'primaryButtonBackgroundColor', defaultValue: '#3171e2' },
    { fieldName: 'primaryButtonFontColor', defaultValue: '#FFFFFF' },
    { fieldName: 'tooltipBackgroundColor', defaultValue: '#3171e2' },
    { fieldName: 'tooltipFontColor', defaultValue: '#FFFFFF' },
    { fieldName: 'brandedChatBubbleColor', defaultValue: '#EBEBEB' },
    { fieldName: 'brandedChatBubbleFontColor', defaultValue: '#333333' },
    { fieldName: 'brandedChatSenderBackgroundColor', defaultValue: '#FFE24B' },
    { fieldName: 'brandedChatSenderFontColor', defaultValue: '#000000' },
    { fieldName: 'notificationBackgroundColor', defaultValue: '#CF0A2C' },
  ];

  defaults.forEach(({ fieldName, defaultValue }) => {
    stylesWithDefaults[fieldName] = getColor(stylesWithDefaults[fieldName], defaultValue);
  });

  return stylesWithDefaults;
}

function addAnimationsToCssString(css, indicator) {
  const bgColorRegExp = new RegExp(`(background-color:\\s+${indicator};)`, 'g');
  const borderColorRegExp = new RegExp(`(border-color:\\s+${indicator};)`, 'g');
  const borderLeftClrRegExp = new RegExp(`(border-left-color:\\s+${indicator};)`, 'g');
  const colorRegExp = new RegExp(`( color:\\s+${indicator};)`, 'g');
  const fillColorRegExp = new RegExp(`( fill:\\s+${indicator};)`, 'g');
  const colorAndBCRegExp = new RegExp(
    `( border-color:\\s+${indicator};color:\\s+${indicator};)`,
    'g',
  );

  // The order of operations matters here
  css = css.replace(colorAndBCRegExp, '$1 animation: highlightColorAndBorderColor 2s infinite;');
  css = css.replace(bgColorRegExp, '$1 animation: highlightBackgroundColor 2s infinite;');
  css = css.replace(borderColorRegExp, '$1 animation: highlightBorderColor 2s infinite;');
  css = css.replace(borderLeftClrRegExp, '$1 animation: highlightBorderLeftColor 2s infinite;');
  css = css.replace(colorRegExp, '$1 animation: highlightColor 2s infinite;');
  css = css.replace(fillColorRegExp, '$1 animation: highlightFillColor 2s infinite;');

  return css;
}

function generateKeyframes(baseColor) {
  const highlightColor = isColorCloseToRed(baseColor) ? 'yellow' : 'red';

  return `
		@keyframes highlightColor {
			0% {color: ${baseColor}; transform: scale(1);}
			10% {color: ${baseColor}; transform: scale(1);}
			30% {color: ${highlightColor};  transform: scale(1.1);}
			60% {color: ${baseColor};  transform: scale(1);}
			100% {color: ${baseColor};  transform: scale(1);}
		}		
		@keyframes highlightFillColor {
			0% {fill: ${baseColor}; transform: scale(1);}
			10% {fill: ${baseColor}; transform: scale(1);}
			30% {fill: ${highlightColor};  transform: scale(1.1);}
			60% {fill: ${baseColor};  transform: scale(1);}
			100% {fill: ${baseColor};  transform: scale(1);}
		}			
		@keyframes highlightBackgroundColor {
			0% {background-color: ${baseColor};  transform: scale(1);}
			10% {background-color: ${baseColor};  transform: scale(1);}
			30% {background-color: ${highlightColor};  transform: scale(1.1);}
			60% {background-color: ${baseColor};  transform: scale(1);}
			100% {background-color: ${baseColor};  transform: scale(1);}
		}		
		@keyframes highlightBorderColor {
			0% {border-color: ${baseColor};  transform: scale(1);}
			10% {border-color: ${baseColor};  transform: scale(1);}
			30% {border-color: ${highlightColor};  transform: scale(1.1);}
			60% {border-color: ${baseColor};  transform: scale(1);}
			100% {border-color: ${baseColor};  transform: scale(1);}
		}		
		@keyframes highlightBorderLeftColor {
			0% {border-left-color: ${baseColor};  transform: scale(1);}
			10% {border-left-color: ${baseColor};  transform: scale(1);}
			30% {border-left-color: ${highlightColor};  transform: scale(1.1);}
			60% {border-left-color: ${baseColor};  transform: scale(1);}
			100% {border-left-color: ${baseColor};  transform: scale(1);}
		}		
		@keyframes highlightColorAndBorderColor {
			0% {color: ${baseColor}; border-color: ${baseColor};  transform: scale(1);}
			10% {color: ${baseColor}; border-color: ${baseColor};  transform: scale(1);}
			30% {color: ${highlightColor}; border-color: ${highlightColor};  transform: scale(1.1);}
			60% {color: ${baseColor}; border-color: ${baseColor};  transform: scale(1);}
			100% {color: ${baseColor}; border-color: ${baseColor};  transform: scale(1);}
		}`;
}

function isColorCloseToRed(color) {
  const MIN_RED_CONTENT = 90;
  const MIN_RED_GREEN_CONTRAST = 2;
  const { red, green } = getRGBValues(color);
  return red > MIN_RED_CONTENT && red / green >= MIN_RED_GREEN_CONTRAST;
}

function getRGBValues(color) {
  let rgbVals = {};
  if (color === 'red') rgbVals = { red: 255, green: 0, blue: 0 };
  // #F03
  if (color.match(/^#[0-9A-F]{3}$/i))
    rgbVals = {
      red: parseInt(color[1] + color[1], 16),
      green: parseInt(color[2] + color[2], 16),
      blue: parseInt(color[3] + color[3], 16),
    };
  // #FF0033
  if (color.match(/^#[0-9A-F]{6}$/i))
    rgbVals = {
      red: parseInt(color.slice(1, 3), 16),
      green: parseInt(color.slice(3, 5), 16),
      blue: parseInt(color.slice(5, 7), 16),
    };
  // rgb(255, 00, ) or rgba(255,03)
  if (color.match(/^rgb(?:a)\((\d{1,3}),(\d{1,3}),(\d{1,3})(?:(,\d{1,3}))\)$/))
    [, rgbVals.red, rgbVals.green, rgbVals.blue] = color.match(
      /^rgb(?:a)\((\d{1,3}),(\d{1,3}),(\d{1,3})(?:(,\d{1,3}))\)$/,
    );
  return rgbVals;
}

export function addHighlightingCapability(styleObj, styleGeneratingFn) {
  let highlightedColor = '';

  styleObj = { ...styleObj };

  const { highlightedField } = styleObj;

  if (highlightedField) {
    highlightedColor = styleObj[highlightedField];
    styleObj[highlightedField] = 'animateThisColor';
  }

  let css = styleGeneratingFn(styleObj);

  if (highlightedColor) {
    css = addAnimationsToCssString(css, 'animateThisColor');
    css += generateKeyframes(highlightedColor);
  }

  return css;
}
